import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import HeartWrapper from './HeartWrapper';
import { FAVOURITE_FILTERS_KEY, FAVORITES_UPDATED_EVENT } from './constants';

interface FavoritesSectionProps {
    componentRegistry: Record<string, React.ReactNode>;
}

const FavoritesSection: React.FC<FavoritesSectionProps> = ({ componentRegistry }) => {
    const [favourites, setFavourites] = useState<string[]>(() =>
        JSON.parse(localStorage.getItem(FAVOURITE_FILTERS_KEY) || '[]')
    );

    useEffect(() => {
        const handleStorageChange = () => {
            setFavourites(JSON.parse(localStorage.getItem(FAVOURITE_FILTERS_KEY) || '[]'));
        };

        window.addEventListener(FAVORITES_UPDATED_EVENT, handleStorageChange);

        return () => {
            window.removeEventListener(FAVORITES_UPDATED_EVENT, handleStorageChange);
        };
    }, []);

    return (
        <div
            className={'bg-lightest border rounded padding-20 margin-bottom-20'}
            onFocusCapture={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <div classname={'display-flex gap-10'}>
                <h4 className={'margin-top-0 margin-bottom-15'}>
                    <FormattedMessage id='intl-msg:favorites' defaultMessage='Favorites'/>
                </h4>
            </div>
            {favourites.length === 0 ? (
                <span className={'text-muted'}>
                    <FormattedMessage
                        id='intl-msg:noFavoriteFilters'
                        defaultMessage='No favorite filters saved. Click the heart icon on any filter to add it here.'
                    />
                </span>
            ) : (
                favourites.map((name: string) => (
                    <div key={`fav-${name}`} className={'margin-bottom-10'}>
                        <HeartWrapper>
                            {componentRegistry[name]}
                        </HeartWrapper>
                    </div>
                ))
            )}
        </div>
    );
};

export default FavoritesSection;
